import React from 'react';
import { useTranslation } from 'react-i18next'; // ✅ Import translation hook
import './Quote.css';
import QuoteSymbolLeft from './../../assets/elements/“2.svg'; 
import QuoteSymbolRigth from './../../assets/elements/“.svg'; 

const Quote: React.FC = () => {
  const { t } = useTranslation(); // ✅ Initialize translation

  return (
    <div className="quote-section-container">
      <div className="quote-section">
        <img src={QuoteSymbolLeft} className="quote-left" alt="" />
        <div className="quote-content">
          <h2 className="quote-title">"{t("quote_text")}"</h2>
          <p className="quote-author">{t("quote_author")}</p>
        </div>
        <img src={QuoteSymbolRigth} className="quote-right" alt="" />
      </div>
    </div>
  );
};

export default Quote;
